export default "__VITE_ASSET__zdJx55p6__"